import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  CreateAccountButtonContainer,
  CreateAccountCenterContainerPaddedTop,
  CreateAccountFormStyled,
  FormFieldInput,
  Spinner,
  VerifyEmailSendAgainInput,
} from "../CreateAccount/CreateAccountForm.styles";
import { Button } from "../shared/Button/Button";
import { patientState } from "../../recoil/atoms";
import { UpdateEmailOnlyRequest } from "../CreateAccount/Services/CreateAccountService";
import { VERIFY_EMAIL_URL } from "../../utils/urlConstants";
import loading from "../../assets/icons/loading.svg";
import { validateEmail } from "../../utils/hooks/helpers";

export const VerifyEmailSendAgainSection = (): React.ReactElement => {
  const { t } = useTranslation();
  const [patientInfo, setPatientInfo] = useRecoilState(patientState);
  const [email, setEmail] = useState(patientInfo?.auth0.email);
  const [emailError, setEmailError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();

  const submit = async () => {
    if (!email) {
      setEmailError(t("verifyEmail.errors.required"));
      return;
    }
    if (!validateEmail(email)) {
      setEmailError(t("verifyEmail.errors.invalidEmail"));
      return;
    }
    setIsSubmitting(true);
    const response = await UpdateEmailOnlyRequest(
      email,
      patientInfo?.auth0.access_token as string,
    );
    if (response && response?.ok && patientInfo) {
      setPatientInfo({
        ...patientInfo,
        auth0: { ...patientInfo.auth0, email },
      });
      history.push(VERIFY_EMAIL_URL);
    } else {
      setErrorMessage(t("verifyEmail.sendAgain.error"));
    }
    setIsSubmitting(false);
  };
  return (
    <CreateAccountCenterContainerPaddedTop>
      {GetTypographyContent({
        content: t("verifyEmail.didNotReceive"),
        size: "h3",
        isBold: true,
        textColor: "neutral700",
        padding: "0 0 24px 0",
      })}
      {GetTypographyContent({
        content: t("verifyEmail.sendAgain.instructions"),
        size: "medium",
        textColor: "neutral700",
        padding: "0 0 24px 0",
      })}
      {GetTypographyContent({
        content: errorMessage,
        size: "medium",
        textColor: "redDark",
      })}
      <CreateAccountFormStyled>
        <FormFieldInput>
          <VerifyEmailSendAgainInput
            label={t("verifyEmail.fields.email")}
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder={email}
            value={email}
            error={emailError}
          />
        </FormFieldInput>
        <CreateAccountButtonContainer>
          {isSubmitting && (
            <Spinner>
              <img src={loading} alt="Loading" />
            </Spinner>
          )}
          {!isSubmitting && (
            <Button
              type="submit"
              label={t("verifyEmail.sendAgain.button")}
              size="medium"
              onClick={submit}
            />
          )}
        </CreateAccountButtonContainer>
      </CreateAccountFormStyled>
    </CreateAccountCenterContainerPaddedTop>
  );
};
